import styled from 'styled-components';

const Date = styled.span`
  color: #666d71;
  display: block;
  font-size: 1.6em;
  margin: 0;
  text-align: center;
`;

export default Date;